import LicenseButton from './licensebutton'

export default LicenseButton
